import { Row } from 'react-bootstrap'
import styles from '../../styles/ArticleRecommendation.module.css'

const ArticleRecommendation = (props: { title: string, children: React.ReactNode }) => {
  return(
    <div className={styles.container}>
      <h2 className='mb-4'>{props.title}</h2>
      <Row>
        {props.children}
      </Row>
    </div>
  )
}

export default ArticleRecommendation